/** Serverzustand der oeffentlichen Umfrage -- F5-10. */

import { useMutation, useQuery } from '@tanstack/react-query';

import type { components } from '../../api/schema';
import { request } from '../../lib/apiClient';
import { ApiError } from '../../lib/apiError';

export type PublicSurvey = components['schemas']['SurveyPublicRead'];

export function usePublicSurvey(token: string) {
  return useQuery({
    queryKey: ['public-survey', token],
    queryFn: () => request<PublicSurvey>(`/public/surveys/${token}`),
    // Ein unbekanntes Merkmal bleibt unbekannt -- eine Wiederholung braechte
    // nur ein zweites 404.
    retry: (failureCount, error) =>
      !(error instanceof ApiError && error.isPermanent) && failureCount < 2,
  });
}

export function useAnswerSurvey(token: string) {
  return useMutation({
    mutationFn: (payload: { rating: number; comment: string }) =>
      request<PublicSurvey>(`/public/surveys/${token}`, { method: 'POST', body: payload }),
  });
}
